const adminAuthKeys = {
  all: ['ADMIN_AUTH'],
  group: () => [...adminAuthKeys.all, 'GROUP'],
};

export default adminAuthKeys;
